// Т. к. подключать monoui - плохая идея, основано на
// monoui/packages/modules/src/components/ui/ConditionallyWrapped/ConditionallyWrapped.tsx

import React, { ComponentType, ComponentProps, ReactNode } from 'react';

type Props<C extends ComponentType<any>> = {
    _by_: C | null | undefined;
    _if_?: unknown;
} & ComponentProps<C> & { children: ReactNode };

export function ConditionallyWrapped<C extends ComponentType<any>>(props: Props<C>) {
    const { _by_: Wrapper, _if_: wrapped = !('_if_' in props), children, ...rest } = props;

    return Wrapper && wrapped ? <Wrapper {...rest}>{children}</Wrapper> : <>{children}</>;
}
